import OrganizationLogoImage from "./components/OrganizationLogoImage";
import { jsx as _jsx } from "react/jsx-runtime";
var Logo = function Logo(_ref) {
  var organizationSlug = _ref.organizationSlug,
    role = _ref.role;
  var handleLogoClick = function handleLogoClick() {
    if (role === 'admin') {
      window.location.href = "/org/".concat(organizationSlug, "/panel/");
    } else if (role === 'user') {
      window.location.href = "/org/".concat(organizationSlug, "/home/");
    }
  };
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    id: "main-menu-logo",
    className: "tw-hidden sm:tw-flex tw-items-center tw-w-[25.6rem] -tw-ml-[6.3rem] tw-justify-center tw-flex-shrink-0  tw-mr-auto",
    disabled: !role,
    onClick: handleLogoClick,
    children: /*#__PURE__*/_jsx(OrganizationLogoImage, {
      alt: organizationSlug
    })
  });
};
export default Logo;